import e from"./is-null-or-undefined.js";var o=e,n=TypeError,l=function(r){if(o(r))throw n("Can't call method on "+r);return r};export{l as default};
